import { useCallback, useState, useEffect } from "react";
import { CURRENT_RELEASE_TIMESTAMP } from "sketon/const";

import axios from "axios";
import { BSBookInfo } from "../data/BSBookInfo";
import { isEmpty } from "sketon/utility/StringUtils";
import moment from "moment";

export const useLoadBooklist = () => {
  const [bookList, setBookList] = useState<BSBookInfo[]>();

  const loadBookList = useCallback(() => {
    return new Promise<BSBookInfo[]>((resolve, reject) => {
      axios
        .get("/books_baowu_2022_cn?t=" + CURRENT_RELEASE_TIMESTAMP)
        .then((response) => {
          if (response.status !== 200) {
            return;
          }
          resolve(response.data);
        })
        .catch((error) => {
          console.debug("useLoadBooklist error:", error);
          reject(error);
        });
    });
  }, []);

  useEffect(() => {
    loadBookList()
      .then((response) => {
        setBookList(response);
      })
      .catch((error) => {
        console.log("setBookList error:", error);
      });
  }, [loadBookList]);

  return bookList;
};

export const useLoadYearBookList = (year: string) => {
  const [bookList, setBookList] = useState<BSBookInfo[]>();

  const allBooks = useLoadBooklist();

  
  useEffect(() => {
    if(isEmpty(year)){
      setBookList(allBooks);
    }else{
      let list : BSBookInfo[] = [];
      allBooks?.map((info : BSBookInfo)=>{
        let mmt = moment(info.date, "YYYY/MM/DD");
        if(mmt.year() == parseInt(year)){
          list.push(info);
        }
      
      })

      setBookList(list);
    }
    
  }, [allBooks, year]);

  if(bookList !== undefined && bookList?.length > 0){
    return bookList;
  }else{
    return undefined;
  }
  

};
